<template>
    <div class="gallery">

        <div class="gallery__active" v-if="activeImage">
            <img :src="activeImage" alt="">
        </div>

        <div class="gallery__thumbnails">
            <img v-for="image in images" :key="image" :class="{ 'active' : activeImage == image }" @click="activeImage = image" :src="image" alt="" class="gallery__thumbnail">
        </div>
    </div>
</template>

<script>
export default {
    props : [ 'images' ],
    data () {
        return {
            activeImage : this.images[0] || false
        }
    }
}
</script>

<style lang="scss" scoped>
    .gallery {
        &__active {
            width: 100%;
        }

        &__thumbnails {
            height: 80px;
            overflow-x: auto;
            display: flex;
        }

        &__thumbnail {
            height: 100%;
            width: auto;
            margin-right: 15px;
        }
    }
</style>